import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import React, { useEffect, useState } from "react";
import ToggleButton from "../../CoreComponents/ToggleButton";
import {
  ManageProducts,
  showMessage,
  getToken,
  ManageRestaurant,
  getNext3amIST,
} from "../../Functionalities/Functions";
import { productListQuery, productMatchesWords, productRows } from "../../Functionalities/productSearch";
import ReactStars from "react-rating-stars-component";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import {
  protocol,
  url,
  is_back_office,
} from "../../Functionalities/Config";
import Categories from "../Category/Categories";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { is_superuser } from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import ProductsList from '../../CoreComponents/ProductsList'

function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [edit, setEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [filter, setfilter] = useState({
    search_text: "",
    category_id: "",
    is_blocked: "",
    is_subscribable: "",
    is_out_of_stock: "",
    branch_id: "",
  });
  const [categories, setcategories] = useState({ id: "", name: "", data: [] });
  const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });
  const [reload, setReload] = useState(false)
  const [loading, setLoading] = useState(true)
  const [stock, setStock] = useState({
    out_of_stock: "",
    item_id: ""
  })


  useEffect(() => {
    getData();
    getCategories();
    is_back_office && getBranches();
    
  }, [reload]);

  const getData = () => {
    const query = productListQuery({
      searchText: filter.search_text,
      franchiseLevel: is_back_office,
    });
    const params =
      query.params +
      "&for_dropdown=false&category_id=" +
      filter.category_id +
      "&is_blocked=" +
      filter.is_blocked +
      "&is_subscribable=" +
      filter.is_subscribable +
      "&is_out_of_stock=" +
      filter.is_out_of_stock +
      "&branch_id=" +
      filter.branch_id;
    let result = ManageProducts("", "", "get", params);
    result
      .then((result) => {
        const rows = productRows(result.data);
        const shown = query.filterInBrowser
          ? rows.filter((product) => productMatchesWords(product, query.words))
          : rows;
        setData({
          ...data,
          data: shown,
          // When the search is filtered in the browser the server's count is
          // the unfiltered total, which would give a page count for rows the
          // page is not showing.
          count: query.filterInBrowser ? shown.length : result.data.count,
        });
        setLoading(false)
        setNext(query.filterInBrowser ? null : result.data.next);
        setPrev(query.filterInBrowser ? null : result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const getCategories = () => {
    let params = "for_dropdown=true&page_wise=false&order_by_name=true";

    var config = {
      method: "get",
      url: url + "/items/category/?" + params,
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setcategories({
          ...categories,
          data: response.data,
        });
      })
      .catch(function (error) {
        // void 0
      });
  };

  const getBranches = () => {

    let params = "for_dropdown=true&page_wise=false&order_by_name=true";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        setrestrarent({
          ...restrarent,
          data: result?.data,
        });
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");

    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace('//', "")),
      // url: prev + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    // alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace('//', "")),
      // url: next + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  return (
    <div className="content-body">

      { !loading ?
        <div className="container-fluid">
          <FilterComponent
            handleNext={handleNext}
            handlePrev={handlePrev}
            next={next}
            prev={prev}
            count={data.count}
            filterButtonName={"Filter"}
            addItemName={ "Add Products"}
            addItemPath={filter.branch ? `/addproducts?branch=${filter.branch}` : "/addproducts"}
          />

          {/* modal Start */}

          <FilterModalComponent
            heading={"Filter Products"}
            searchItemValue={filter.search_text}
            searchItemChange={(e) =>
            
              setfilter({
                ...filter,
                search_text: e.target.value,
              })
            }
            clearFilter={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
            submitFilter={(e) => {
              e.preventDefault();
              getData();
            }}
          >
            {/* <div className="col-lg-6">
              <div className="form-group">
                <label className="text-black font-w600">
                  Category <span className="required"></span>
                </label>
                <select
                  value={filter.category_id}
                  class="form-control form-control-lg  "
                  onChange={(e) =>
                    setfilter({
                      ...filter,
                      category_id: e.target.value,
                    })
                  }
                >
                  <option value={""} id={""}>
                    All
                </option>
                  {categories.data.map((item) => (
                    <option value={item.id} id={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}

            {is_back_office && (
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Restaurant <span className="required"></span>
                  </label>
                  <select
                    value={filter.branch_id}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        branch_id: e.target.value,
                      })
                    }
                  >
                    <option value={""} id={""}>
                      All
                  </option>
                    {restrarent?.data?.map((item) => (
                      <option value={item.id} id={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="col-lg-6">
              <div className="form-group">
                <label className="text-black font-w600">
                  Blocked <span className="required"></span>
                </label>
                <select
                  value={filter.is_blocked}
                  class="form-control form-control-lg  "
                  onChange={(e) =>
                    setfilter({
                      ...filter,
                      is_blocked: e.target.value,
                    })
                  }
                >
                  <option value={""} id={""}>
                    All
                </option>
                  <option value={"true"} id={"true"}>
                    Yes
                </option>
                  <option value={"false"} id={"false"}>
                    No
                </option>
                </select>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label className="text-black font-w600">
                  Out of Stock <span className="required"></span>
                </label>
                <select
                  value={filter.is_out_of_stock}
                  class="form-control form-control-lg  "
                  onChange={(e) =>
                    setfilter({
                      ...filter,
                      is_out_of_stock: e.target.value,
                    })
                  }
                >
                  <option value={""} id={""}>
                    All
                </option>
                  <option value={"true"} id={"true"}>
                    Yes
                </option>
                  <option value={"false"} id={"false"}>
                    No
                </option>
                </select>
              </div>
            </div>
          </FilterModalComponent>

          {/* modal End */}

          <ProductsList
            data={data.data}
            toggle={
              (e, itemid, index) => {
                // void 0

                setStock({ ...stock, out_of_stock: !e, item_id: itemid })

                var x = { ...stock, out_of_stock: !e, item_id: itemid }
                let result = ManageProducts(e, x, 'patch', '')
                result.then(result => {
                  if (result.data.Status === true) {
                    var newData = data.data
                    var newObj = newData[index]
                    newObj = { ...newObj, is_out_of_stock: !e }
                    newData[index] = newObj
                    setData({ ...data, data: newData })

                    // alert('success')
                    // void 0
                    //window.location.reload()
                    // setReload(!reload)
                  }
                  else {
                    showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0)
                    // alert('error')
                  }
                })
                  .catch((error) => {
                    // void 0
                  })
              }
            }
            toggleSale={(itemid, index, on, pct) => {
              const x = { keyword: "sale", item_id: itemid, on_sale: on, sale_discount: pct };
              ManageProducts("", x, "patch", "")
                .then((result) => {
                  if (result.data.Status === true) {
                    const newData = [...data.data];
                    newData[index] = { ...newData[index], on_sale: on, sale_discount: on ? pct : null };
                    setData({ ...data, data: newData });
                  } else {
                    showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0);
                  }
                })
                .catch(() => {});
            }}
            toggleTempUnavailable={
              (e, itemid, index) => {
                let x = { keyword: "temporarily_unavailable", temporarily_unavailable: !e, item_id: itemid };
                let result = ManageProducts(e, x, 'patch', '');
                result.then(result => {
                  if (result.data.Status === true) {
                    var newData = data.data;
                    var newObj = newData[index];
                    newObj = { 
                      ...newObj, 
                      is_temporarily_unavailable: !e,
                      unavailable_until: !e ? getNext3amIST() : null
                    };
                    newData[index] = newObj;
                    setData({ ...data, data: newData });
                    showMessage(
                      "success",
                      "Product status updated successfully!",
                      "top",
                      "top-right",
                      1500
                    );
                  }
                  else {
                    showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0);
                  }
                })
                  .catch((error) => {});
              }
            }
          />
        </div>

        : <LoadingComponent />
      }
    </div>
  );
}

function Products() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Products"} subHeading={"All products under foodoor"} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Products;
